import { toast } from "sonner";
import { useTeamMutations } from "@/hooks/use-team-mutations";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export function RemoveTeamMemberDialog({
  teamId,
  member,
  open,
  onOpenChange,
}: {
  teamId: string;
  member: { userId: string; name: string } | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const { removeTeamMember } = useTeamMutations();

  async function handleConfirm() {
    if (!member) return;
    try {
      await removeTeamMember.mutateAsync({ teamId, userId: member.userId });
      toast.success(`Removed ${member.name} from team`);
      onOpenChange(false);
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Failed to remove member");
    }
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Remove from team?</AlertDialogTitle>
          <AlertDialogDescription>
            This will remove <strong>{member?.name}</strong> from this team. They will remain
            a member of the organization.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm} disabled={removeTeamMember.isPending}>
            Remove
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
